import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { PortalShell } from './components/layout/PortalShell';
import { Home } from './pages/Home';
import { SectionView } from './pages/SectionView';
import { SupplierNetwork } from './pages/SupplierNetwork';
import { PinGate } from './components/PinGate';
export function App() {
  return <PinGate data-id="element-0">
      <Router data-id="element-1">
        <PortalShell data-id="element-2">
          <Routes data-id="element-3">
            <Route path="/" element={<Home data-id="element-5" />} data-id="element-4" />
            <Route path="/section/:id" element={<SectionView data-id="element-7" />} data-id="element-6" />
            <Route path="/supplier-network" element={<SupplierNetwork data-id="element-9" />} data-id="element-8" />
          </Routes>
        </PortalShell>
      </Router>
    </PinGate>;
}